import React, { useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { authStore } from '../stores/AuthStore';
import { Calendar } from '../components/Calendar';
import '../styles/DashboardPage.css';

export const DashboardPage: React.FC = observer(() => {
  useEffect(() => {
    // TODO: Fetch dashboard data from API
    // Example: GET /api/dashboard/stats
  }, []);

  return (
    <div className="dashboard-page">
      <Calendar />
    </div>
  );
});
